import { DatePipe } from '@angular/common';
import { OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef, Component, QueryList, ViewChildren, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InPlaceEditor } from '@syncfusion/ej2-inplace-editor';
import { UUID } from 'angular2-uuid';
import { ToastrService } from 'ngx-toastr';
import { fadeInOut } from '../../shared/helpers/animations';
import { ILLCompany, ILLCustomerCompaniesByTypeWrapper, ISplValidation, ILLGenericKeys, IContactDetail, ICompanyDetail, IEntity, ISSDPConctact, ILLBusinessCategory } from '../../shared/models/index';
import { AuthorizationService, CompanyContactService, LLFormService } from '../../shared/services';
import { StorageManagerService } from '../../shared/services/index';
import { Utilities } from '../../shared/services/utilities';
import { ExpandEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { ErrorMessagesComponent, CompanyDetailsComponent, ContactComponent } from '../../components/index';
import { closest, EmitType } from '@syncfusion/ej2-base';
import { Subscription, Subject, of, forkJoin } from 'rxjs';
import { LCRFormService } from '../../shared/services/lcr-form.service';
import { ILCRRevisionHistory } from '../../shared/models/lcr-revision-history.model';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { LCRData } from '../../shared/models/lcr.model';
import { LCRValidationService } from '../../shared/services/lcr-validation.service';
import { RefdataService } from '../../shared/services/refdata.service';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'app-lcr-form',
    templateUrl: './lcr-form.component.html',
    styleUrls: ['./lcr-form.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    animations: [fadeInOut]
})
export class LCRFormComponent implements OnInit, OnDestroy, AfterViewInit {
    public frmLCR: UntypedFormGroup;
    @ViewChild('revHistoryDialog') revHistoryDialog: DialogComponent;
    @ViewChildren(ErrorMessagesComponent) errorMessages: QueryList<ErrorMessagesComponent>;
    @ViewChild('buildModalDialog') buildModalDialog: DialogComponent;
    @ViewChild('ndcLablerCode') ndcLabelerCodeDrp: DropDownListComponent;
    @ViewChild('lablerCompany') lablerCompany: DropDownListComponent;
    @ViewChild('companyDialog') public companyDialog: DialogComponent;
    @ViewChild('companyDetails') public companyDetailsComponent: CompanyDetailsComponent;
    @ViewChild('contact') public contactComponent: ContactComponent;
    @ViewChild('contactDialog') public contactDialog: DialogComponent;

    lcrData: LCRData;
    errorMessagesComponent: ErrorMessagesComponent;
    public clickEventArgs: Event;
    sub: Subscription;
    position: object = { X: 'center', Y: 'center' };
    modalWidth = '30%';
    modalHeight = 'auto';
    animationSettings: Object = { effect: 'Zoom' };
    isModal = true;
    revHistoryVisible = false;
    buildModalDialogVisible = false;
    formName: string;
    current = false;
    public type = 'Push';
    public enablePersistence = false;
    confirmDialogSelection$: Subject<boolean> = new Subject<boolean>();
    submitted = false;
    lcrRevisionId: string;
    errorMessage: string;
    setId: string;
    busCategoryId: any;
    bHasPermission = false;
    setIdModel: object;
    businessCategoryModel: object;
    status: string;
    splVersion: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    public dateValue: Date = new Date();
    setIdObj: InPlaceEditor;
    drpLabelerCompanyLOV: any[] = [];
    drpNdcLabelerCodeLOV: any[] = [];
    splTransmissionTypeLOV: any[] = [];
    labelCompanyRevisionId: number;
    labelCompanyContactRevisionId: string;
    ndcLablerCode: string;
    allLOV: any[] = [];
    labelerCompanies: ILLCompany[] = [];
    rules = { setId: { required: true } };
    lcrRevisions: ILCRRevisionHistory[];
    lcrRevisionCurrentRevision: ILCRRevisionHistory;
    companyRevisionId: number;
    companyDetailUrl: string;
    contactDetailUrl: string;
    bShowViewContactLink = false;
    bShowViewCompanyLink = false;
    companyDetail: ICompanyDetail;
    versionToDisplay: string;
    ignoreWarnings = false;
    displayLabelerContact = false;
    splSubmissionTypeMissing = true;
    labelerCompanyMissing = true;
    revisionDate: null;
    revisionDateMissing = true;
    forms: any[];
    isCompanyInactive = false;
    isContactInactive = false;
    inactiveLabelerCompanyName: string;
    inactiveLabelerContactName: string;
    iconTypeCompany = true;
    iconTypeContact = false;
    countries: IEntity[] = [];
    contactDetail: IContactDetail;
    companyToViewRevisionId: number;
    parentComponent: any;
    customerGuid: string;
    companyData: any;
    isDraftMode: boolean = false;

    labelerCompanyFields: Object = { text: 'name', value: 'id' };
    labelerCodeFields: Object = { text: 'label', value: 'label' };
    splTransmissionTypeFields: Object = { text: 'labelAndCode', value: 'id' };
    public ddwHeight = '220px';
    public ddwWidth = '450px';
    drpWaterMark = 'Select One';
    NDC_LABELER_CODE_INACTIVATION = '69968-6';
    NDC_LABELER_CODE_INACTIVATION_ANIMAL_DRUG = '81204-0';
    public animationSettings_dialog: Object = { effect: 'Fade' };
    splValidationMessages: ISplValidation = new ISplValidation();
    showValidationMessages: boolean;
    pageLoading = false;
    // Button Spinners
    buildLoading = false;
    validateLoading = false;
    saveLoading = false;
    buildLCRComplete = false;
    contactNotAssociated = false;
    updatedVersion: string;
    public hidden: Boolean = false;
    canCreateCompany: boolean;

    frmDetailData: any;
    formData: any;
    routerUrl: string;
    invalidSplVersion = false;
    isEditMode: boolean = false;
    hasDeletePermission: boolean = false;

    @ViewChild('tooltipObj') public tooltipObj: TooltipComponent;
    dateFormat: string;

    constructor (
        private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router,
        private lcrService: LCRFormService, public datepipe: DatePipe, private llService: LLFormService,
        private toastr: ToastrService, private storageManagerService: StorageManagerService,
        private authorizationService: AuthorizationService, private utilService: Utilities,
        private validationService: LCRValidationService, private companyService: CompanyContactService,
        private cdRef: ChangeDetectorRef,
        private refDataService: RefdataService, private llservice: LLFormService) {
    }

    ngOnInit() {
        this.frmLCR = this.fb.group({
            setId: [''],
            formName: [''],
            phoneNumber: [''],
            contactName: [''],
            dunsNumber: [''],
            emailAddress: [''],
            address: [''],
            cityStateCountry: [''],
            drpSplTransmissionType: [''],
            splRevisionDate: [''],
            drpBusinessCategory: [''],
            drpLabelerCompany: [''],
            drpNdcLabelerCode: ['']
        });

        // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
        this.initTabIndex();

        // Initialiaztion
        this.initParams();
        // Populate the controls with previously saved data
        this.populateDataFromResolver();
        this.populateHeaders();

        // Validation error handling
        this.initValidation();

        // Fix for footer spacing issues
        document.getElementsByTagName('footer')[0].classList.add("footer-spacing-fix");

        this.dateFormat = Utilities.getLocaleDateString();
    }

    initTabIndex() {
      (document.activeElement as HTMLElement).blur();

      const main = document.getElementById('firstDiv');

      if (main) {
        main.focus();
      }
    }

    // Initialization
    initParams() {
        // disable the company dropdown to prevent the user from switching client from the form
        this.utilService.toggleClientDropdownState(true);
        this.getLCRFormRevisionId();
        this.formData = this.activatedRoute.snapshot.data['formData'];
        if (this.formData && this.formData[0] && this.formData[0].data && this.formData[0].data.contact) {
            this.contactNotAssociated = this.formData[0].data.contact.contactRevisionId === 0
        }

        if(this.formData && this.formData[0] && this.formData[0].data){
            this.isDraftMode = this.formData[0].data.majorRevision === 0;
        }

        this.labelerCompanyMissing = true;
        // Check if user has write permission. If no, disable the "Save", "Save a draft" buttons
        this.checkUserPermission();
        this.routerUrl = this.router.url;
        this.isContactInactive = false;
        this.isCompanyInactive = false;

        this.parentComponent = this;

      const currentCustomerStr = this.storageManagerService.read('currentCustomer');


    if (currentCustomerStr) {
        const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
      if (currentCustomer) {
        this.customerGuid = currentCustomer.customerGuid;
      }
    }
    }

    // populate Header Section
    populateHeaders() {
        if (this.frmDetailData) {
            if (this.lcrRevisionId) {
                this.setId = this.frmDetailData.setId;
                this.status = this.frmDetailData.isDraftMode === true ? 'Draft' : 'Active';
                this.lastModifiedBy = this.frmDetailData.modifiedByUser ? this.frmDetailData.modifiedByUser : this.frmDetailData.createUser;
                this.lastModifiedDate = this.datepipe.transform(this.frmDetailData.modifiedByDate, 'MMM d, y');
                this.splSubmissionTypeMissing = this.frmDetailData.splServiceType.id && +this.frmDetailData.splServiceType.id !== 0 ? false : true;
                this.revisionDateMissing = this.f.splRevisionDate.value ? false : true;
                this.busCategoryId = this.frmDetailData.busCategory ? +this.frmDetailData.busCategory.categoryId : null;
                this.splVersion = this.frmDetailData.splVersion;

                this.frmLCR.patchValue({
                    drpSplTransmissionType: this.frmDetailData.splServiceType ? +this.frmDetailData.splServiceType.id : 0,
                    drpBusinessCategory: this.busCategoryId,
                    splRevisionDate: this.frmDetailData.effectiveTime
                });
            }
            this.setIdModel = {
                placeholder: 'Enter setId',
                value: this.frmDetailData.setId,
            };
        }
    }

    // when user change a labeler company
    labelerCompanySelectionChanged(event) {
        let companyDetail: ILLCompany[] = [];

        this.isContactInactive = false;
        this.isCompanyInactive = false;
        if (event.itemData) {
            this.displayLabelerContact = true;

            this.companyRevisionId = event ? event.value : 0;
            this.bShowViewContactLink = false;
            this.bShowViewCompanyLink = false;
            this.labelerCompanyMissing = false;

            if (this.companyRevisionId) {
                // find this company record
                companyDetail = this.labelerCompanies.filter(x => x.companyRevisionId === this.companyRevisionId);
                if (companyDetail && companyDetail.length > 0) {
                    this.displayCompanyAndAssociatedContactDetail(companyDetail[0]);
                }
            }
        } else {// selection being removed
            this.labelerCompanyMissing = true;
            this.bShowViewCompanyLink = false;
            this.displayLabelerContact = false;
        }

        if (event.isInteracted) {
            this.frmLCR.markAsDirty();
        }
    }

    // Validation error handling
    initValidation() {
        // Now, read the validation errors from local storage (if present)
        if (this.storageManagerService.read('showValidationMessages')) {
            this.splValidationMessages = this.storageManagerService.read('splValidationMessages');
        }
        this.storageManagerService.write('showValidationMessages', false);
        this.storageManagerService.write('splValidationMessages', {});
        this.frmLCR.markAsPristine();
    }

    // Dynamically generate new GUID
    generateGUID() {
        this.setId = UUID.UUID();
        this.frmLCR.markAsDirty();
    }

    // Get LCRForm RevisionId
    getLCRFormRevisionId() {
        this.lcrRevisionId = this.activatedRoute.snapshot.params.revisionId;

        // set edit mode based on value of revision id from route params (integer > 0 = edit mode)
        const parsedRevisionId = parseInt(this.lcrRevisionId);
        this.isEditMode = !isNaN(parsedRevisionId) && parsedRevisionId > 0;
    }

    // Get a form control by name
    getFormControlByName(controlName: string): UntypedFormControl {
        return <UntypedFormControl>this.frmLCR.get(controlName);
    }

    // Check if user has write permission. If no, disable the "Save", "Save a draft" buttons
    checkUserPermission() {
        if (this.authorizationService.hasPermission('SSDP.CanWriteLCRForm')) {
            this.bHasPermission = true;
        }

        if(this.authorizationService.hasPermission('SSDP.CanDeleteLCRForm')){
            this.hasDeletePermission = true;
        }

        if (this.authorizationService.hasPermission('SSDP.CanWriteCompany')) {
            this.canCreateCompany = true;
        }
    }

    // Get data from the resolver and populate the controls
  populateDataFromResolver() {
      if (this.formData.error) {
          this.toastr.error(this.formData.error);
      } else {
      if (this.formData) {
        // Countries
        if (this.formData[5]) {
          this.countries = this.formData[5]['countryList'];
        }

        // Labeler company
        if (this.formData[2]) {
          // populate the Labeler Company dropdown
          this.populateLabelerCompanyDrp();
        }

        // Submission types
        if (this.formData[1]) {
          this.allLOV = this.formData[1]['data'];
          this.splTransmissionTypeLOV = this.getLOVDataByType('doc_type_lcr');
        }

        // Business Categories
        if (this.formData[3]) {
          this.businessCategoryModel = {
            placeholder: 'Select Business Category',
            dataSource: this.formData[3],
            fields: { value: 'categoryId', text: 'label' },
            width: '200px'
          };
        }

        if (this.formData[0] && this.formData[0]['data']) {
          this.frmDetailData = this.formData[0]['data'];
          this.formName = this.frmDetailData['company'].companyName;
          this.ndcLablerCode = this.frmDetailData.ndcLabelerCode;
          const companyDetail: ILLCompany = this.formData[0]['data']['company'];
          this.displayCompanyAndAssociatedContactDetail(companyDetail);
        }

        // Revision History
        if (this.formData[4] && this.formData[4]['data']) {
          this.lcrRevisions = this.formData[4]['data'];
          if (this.lcrRevisions && this.lcrRevisions.length > 0) {
            this.lcrRevisionCurrentRevision = this.lcrRevisions[0];
            this.current = this.lcrRevisions[0].lcrRevisionId === +this.lcrRevisionId;
            const revision = this.lcrRevisions.find(r => r.lcrRevisionId === +this.lcrRevisionId);
            if (revision) {
              this.versionToDisplay = this.lcrRevisions.find(r => r.lcrRevisionId === +this.lcrRevisionId).formVersion;
            }
          }
        }
      }
    }
    }

    // Get a list of LOVs by doc_type, created a new column that will
    // concatenate label and code fields for displaying purpose
    getLOVDataByType(type: string): any[] {
        const dataLOV = this.allLOV.filter(x => x.lsP_FORM_TYPE === type);
        const newLOV = dataLOV.map(item => {
            const container = {};
            container['id'] = item['id'];
            container['label'] = item['label'];
            container['labelAndCode'] = item['label'] + ' (' + item['code'] + ')';
            return container;
        });

        return newLOV;
    }

    // when user change the spl transmission type dropdown
    splTransmissionTypeSelectionChanged(event) {
        this.frmLCR.markAsDirty();

        if (event.itemData) {
            this.splSubmissionTypeMissing = false;
        } else {// selection being removed
            this.splSubmissionTypeMissing = true;
        }
    }

  // When user click on the date picker for SPL Revision Date
    revisionDateChanged(event) {
        this.frmLCR.markAsDirty();
    }

    // Depending on the SPL transmission type being selected, check if
    // labeler code is required or not
    checkForSPLTransmissionType(): boolean {
        let bIsRequired = false;

        const formValue = this.frmLCR.value;
        const splServiceType = this.getGenericKeyObject(this.splTransmissionTypeLOV, formValue['drpSplTransmissionType'], 'label', 'id');
        const labelerCodeDesc = splServiceType.code;

        if (labelerCodeDesc === this.NDC_LABELER_CODE_INACTIVATION || labelerCodeDesc === this.NDC_LABELER_CODE_INACTIVATION_ANIMAL_DRUG) {
            bIsRequired = true;
        }

        return bIsRequired;
    }

    // populate the Labeler Company dropdown
    populateLabelerCompanyDrp() {
        const companyTypes: ILLCustomerCompaniesByTypeWrapper = this.formData[2].data;
        this.labelerCompanies = companyTypes.labelers;

        if (this.labelerCompanies && this.labelerCompanies.length > 0) {
            this.labelerCompanies.forEach((company: ILLCompany) => {
                const ds = { id: 0, name: '' };
                ds.id = +company.companyRevisionId;
                ds.name = company.companyName;
                this.drpLabelerCompanyLOV.push(ds);
            });
        }
    }

    // Get ndc labeler codes for selected labeler company
    displayCompanyAndAssociatedContactDetail(companyDetail: ILLCompany) {
        let labelerCompanyName = '';

        if (companyDetail) {
            // populate the ndc labeler code dropdown for this company
            this.drpNdcLabelerCodeLOV = companyDetail.ndcLabelerCodes;

            this.labelCompanyRevisionId = companyDetail.companyRevisionId;
            // form has previously saved labeler company
            if (this.labelCompanyRevisionId) {
                this.displayLabelerContact = true;

                // see if the previously saved labeler company is the latest version
                if (this.isCompanyLatest(this.drpLabelerCompanyLOV, this.labelCompanyRevisionId)) {
                    this.companyDetailUrl = `/company-details/${ companyDetail.companyRevisionId }`;
                    this.bShowViewCompanyLink = true;
                    this.labelerCompanyMissing = false;

                    // get labeler company name without duns number
                    if (this.lablerCompany && this.lablerCompany.text) {
                        labelerCompanyName = this.lablerCompany.text;
                        // labelerCompanyName = labelerCompanyName.substr(0, labelerCompanyName.indexOf('('));
                    }
                    this.frmLCR.patchValue({
                        drpLabelerCompany: +companyDetail.companyRevisionId
                    });
                } else {
                    this.isCompanyInactive = true;
                    this.inactiveLabelerCompanyName = companyDetail.companyName;
              }

                this.formName = companyDetail.companyName;

                // Display company info
                this.frmLCR.patchValue({
                    formName: this.formName,
                    drpNdcLabelerCode: this.ndcLablerCode,
                    dunsNumber: companyDetail.dunsNumber,
                    drpLabelerCompany: this.labelCompanyRevisionId
                });

                // Associate contact for this labeler company
                this.frmLCR.patchValue({
                    emailAddress: '',
                    phoneNumber: '',
                    contactName: '',
                    address: '',
                    cityStateCountry: ''
                });
              if (companyDetail.contacts && companyDetail.contacts.length > 0) {
                const contact: ISSDPConctact = companyDetail.contacts[0];
                if (contact && contact.contactRevisionId) {
                  this.labelCompanyContactRevisionId = contact.contactRevisionId;
                  this.contactNotAssociated = false;
                  this.bShowViewContactLink = true;
                  this.contactDetailUrl = `/contact/${this.labelCompanyContactRevisionId}`;

                  // check whether the contact that is associated with the selected company is the latest or not
                  this.isContactLatest(contact);

                  // Get country name
                  let country = '';
                  const countries = contact.country.id ? this.countries.find(c => c.id === contact.country.id) : [];
                  if (countries) {
                    country = countries[0].label;
                  }

                  // Display contact info
                  this.frmLCR.patchValue({
                    emailAddress: contact.email ? contact.email : '',
                    phoneNumber: `${contact.phoneArea} ${contact.areaCode}-${contact.phone} ${contact.phoneExt ? 'ext.' : ''} ${contact.phoneExt === null ? '' : contact.phoneExt}`,
                    contactName: `${contact.firstName} ${contact.lastName}`,
                    address: contact.address,
                    cityStateCountry: `${contact.city}, ${contact.state ?? ''} ${contact.zip ?? ''} ${contact.country.label}`
                  });
                }
              }
              else {
                this.contactNotAssociated = true;
                this.labelCompanyContactRevisionId = '';
              }
            }
        }

    }

    // Check if the previously saved company is the latest version
    isCompanyLatest(companyLov: any[], companyRevisionId: number) {
        let returnVal = true;
        const list = companyLov.filter(x => x.id === companyRevisionId);
        if (list.length === 0) {
            returnVal = false;
        }
        return returnVal;
    }

    // Check if the previously saved contact for the company is the latest version
    isContactLatest(contact: ISSDPConctact) {
        this.companyService.getContacts().subscribe(data => {
            if (data) {
                const contacts = data['latestAvailableContactsList'];
                const list = contacts.filter(x => x.contactRevisionId === contact.contactRevisionId);
                if (list.length === 0) {
                    this.isContactInactive = true;
                    this.inactiveLabelerContactName = `${ contact.firstName } ${ contact.lastName }`;
                    this.cdRef.detectChanges();
                }
            }
        },
          error => {
            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
          }
        );
    }

    // get form data for saving
    getFormData() {
        this.lcrData = new LCRData();
        const companyDetail = new ICompanyDetail();
        const contactDetail = new IContactDetail();
        const formValue = this.frmLCR.value;

        companyDetail.companyRevisionId = formValue['drpLabelerCompany'];
        companyDetail.companyName = formValue['formName'] ? formValue['formName'] : (this.lablerCompany.text ? this.lablerCompany.text.substring(0, this.lablerCompany.text.indexOf('(')) : '');
        this.lcrData.company = companyDetail;

        if (this.labelCompanyContactRevisionId) {
          contactDetail.contactRevisionId = this.labelCompanyContactRevisionId;
        }

        this.lcrData.contact = contactDetail;

        this.lcrData.lcrRevisionId = this.lcrRevisionId ? +this.lcrRevisionId : 0;
        this.lcrData.setId = this.setId;
        this.lcrData.ndcLabelerCode = formValue['drpNdcLabelerCode'];
        if (formValue['splRevisionDate'] !== '') {
          this.lcrData.effectiveTime = formValue['splRevisionDate'] instanceof Date ? formValue['splRevisionDate'].toDateString() : formValue['splRevisionDate'];
        }
        this.lcrData.splServiceType = this.getGenericKeyObject(this.splTransmissionTypeLOV, formValue['drpSplTransmissionType'], 'label', 'id');
        this.lcrData.busCategory = this.getGenericKeyObjectForBC(this.formData[3], this.busCategoryId ? this.busCategoryId.toString() : '');

        this.lcrData.modifiedByUser = this.lastModifiedBy ? this.lastModifiedBy : this.storageManagerService.read('userData').name;
        this.lcrData.modifiedByDate = new Date();
        this.lcrData.splVersion = this.splVersion ? +this.splVersion : 1;
        this.lcrData.lcrId = this.frmDetailData ? this.frmDetailData.lcrId : 0;
    }

    // Build an ILLBusinessCategory object for Business Category
    getGenericKeyObjectForBC(list: any[], id: any): ILLBusinessCategory {
        const retVal = new ILLBusinessCategory();

        if (list && id) {
            list = list.filter(x => x['categoryId'] === id);
            if (list && list.length > 0) {
                retVal.categoryId = id && id !== '0' ? id : '';
                retVal.label = list[0]['label'];
            }
        }

        return retVal;
    }

    // Build an ILLGenericKeys object using id and the object list
    getGenericKeyObject(list: any[], id: any, TextFieldName: string, idFieldName: string): ILLGenericKeys {
        const retVal = new ILLGenericKeys();

        list = list.filter(x => x[idFieldName] === +id);
        if (list && list.length > 0) {
            retVal.id = id;
            retVal.code = this.getCode(list[0]['labelAndCode']);
            retVal.label = list[0][TextFieldName];
        }

        return retVal;
    }

    // get code from description
    getCode(desc: string): string {
        let code = '';

        if (desc) {
            const pos = desc.indexOf('(');
            if (pos || pos === 0) {
                code = desc.substring(pos + 1, desc.length - 1);
            }
        }
        return code;
    }

    // when user enter value in inplace editor object
    editorChanged(event) {
        const column = event.data.name;
        const value = event.data.value;

        switch (column) {
            case 'setId':
                this.setId = value;
                break;
            case 'drpBusinessCategory':
                this.busCategoryId = value;
                break;
        }
        this.frmLCR.markAsDirty();
    }

    saveLCRForm(isDraft: boolean, isValidate: boolean, isBuild: boolean): void {
        // SPL Revision Date and NDC Labeler Code is not required for "Save a draft"
        this.clearOutValidators();

        this.submitted = true;
        this.pageLoading = true;
        this.saveLoading = true;
        this.errorMessage = '';
        const modifiedByUser = this.storageManagerService.read('userData').name;

        // stop here if form is invalid
        if (this.frmLCR.invalid) {
            // Reset various flags
            this.resetFlags();
        } else {
            // New form will not be saved without changes on sections.
            if (this.frmLCR.dirty) {
                // get form data for saving
                this.getFormData();

                this.sub = this.lcrService.saveLCRForm(this.lcrData, modifiedByUser, isDraft).subscribe((response) => {
                    // Reset various flags
                    this.resetFlags();
                    this.cdRef.detectChanges();

                    if (response?.isSuccess) {
                        this.toastr.success(`${ response?.message }`);
                        this.router.navigate([`/lcr-form/${ response?.data?.lcrRevisionId }`]);

                    } else {
                        this.errorMessage = response && response.message ? response.message : 'Form creation failed!';
                        this.toastr.error(this.errorMessage);
                    }
                },
                    error => {
                        // Reset various flags
                        this.resetFlags();
                        this.toastr.error(error.errorMessage ? error.errorMessage : error);
                    }
                );
                this.frmLCR.markAsPristine();

            } else {
                // Reset various flags
                this.resetFlags();
                this.toastr.warning('No changes to save.');
            }
        }
    }

    // Reset various flags
    resetFlags() {
        this.pageLoading = false;
        this.saveLoading = false;
        this.buildLoading = false;
    }

    // Clear out required validators for SPL Revision Date and NDC labeler code
    clearOutValidators() {
        this.f.splRevisionDate.clearValidators();
        this.f.splRevisionDate.updateValueAndValidity();
        this.f.drpNdcLabelerCode.clearValidators();
        this.f.drpNdcLabelerCode.updateValueAndValidity();
    }

    // Validate LCR form
    validateLCR() {
        // SPL Revision Date and NDC Labeler Code is not required for "Validate"
        this.clearOutValidators()
        this.submitted = true;

        // First we need to save the current LCR as a draft (if Form is dirty) so that all data is saved.
        const modifiedByUser = this.storageManagerService.read('userData').name;
        this.getFormData();

        const lcrRevisionId = this.activatedRoute.snapshot.params.revisionId;
        let hasChanges = false;
        const ignoreWarningsValidate = false;
        this.validateLoading = true;
        this.pageLoading = true;
        if (this.frmLCR.dirty) {
            hasChanges = true;
        }

        // stop here if form is invalid
        if (this.frmLCR.invalid) {
            this.pageLoading = false;
            this.validateLoading = false;
        } else {
            this.validationService.validateLCR(this.lcrData, lcrRevisionId, modifiedByUser, hasChanges, ignoreWarningsValidate).subscribe(response => {
                if (response?.isSuccess) {
                    this.pageLoading = false;
                    this.validateLoading = false;

                    if (hasChanges) {
                        this.toastr.success(`Successfully Saved Draft Form: ${ response?.data?.lcrRevisionId }`)
                        // The form has changed so reload the page and show the Validation Messages
                        this.storageManagerService.write('showValidationMessages', true);

                        // store this in localStorage so that we can display them on page load
                        this.storageManagerService.write('splValidationMessages', response?.data?.validationMessages);

                        this.router.navigate([`/lcr-form/${ response?.data?.lcrRevisionId }`]);
                    } else {
                        this.toastr.success(`Successfully Validated Form: ${ lcrRevisionId }`)
                        this.splValidationMessages = response?.data;
                        this.showValidationMessages = Object.keys(this.splValidationMessages.validationMessages).length > 0;

                        if (this.showValidationMessages) {
                            if (this.errorMessagesComponent) {
                                this.pageLoading = false;
                                this.validateLoading = false;
                                this.errorMessagesComponent.showMessages(this.splValidationMessages);
                            }
                        }
                        this.cdRef.detectChanges();
                    }
                } else {
                    // something went wrong when performing Validate
                    this.toastr.error(`${ response?.message }`)
                    this.pageLoading = false;
                    this.validateLoading = false;
                    this.cdRef.detectChanges();
                }
                this.frmLCR.markAsPristine();
            },
              error => {
                this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
                this.pageLoading = false;
                this.validateLoading = false;
                this.cdRef.detectChanges();
            });
        }
    }

    public expanding(e: ExpandEventArgs) {
        if (this.clickEventArgs) {

            const header = closest(this.clickEventArgs.target as Element, '.e-acrdn-header');
            const checkboxEle = closest(this.clickEventArgs.target as HTMLInputElement, 'label');
            if (header && checkboxEle) {
                e.cancel = true;
                return;
            }
        }
    }

    // This method will be used to Build the LCR.
    buildLCR() {
        const modifiedByUser = this.storageManagerService.read('userData').name;
        this.getFormData();

        if (this.frmLCR.invalid) { // stop here if form is invalid
            this.pageLoading = false;
            this.saveLoading = false;
            this.buildLoading = false;
        } else { // Call endpoint to build SPL
            this.validationService.buildLCR(this.lcrData, modifiedByUser, this.ignoreWarnings, +this.updatedVersion).subscribe(response => {
                if (response?.isSuccess) {
                    if (response?.message.indexOf('Errors') >= 0) {
                        this.toastr.error(`${ response.message }`);
                    } else {
                        this.toastr.success(`${ response?.message }`);
                    }
                    // The form might have changed so reload the page and show the Validation Messages
                    this.storageManagerService.write('showValidationMessages', true);

                    // store this in localStorage so that we can display them on page load
                    this.storageManagerService.write('splValidationMessages', response?.data?.validationMessages);

                    if (response?.data?.validationMessages) {
                        this.router.navigate([`/lcr-form/${ response.data?.lcrRevisionId }`]);
                    } else {
                        this.toastr.success('Your SPL XML file is being generated.  When the process is complete, the file will be available on the Deliveries tab.');
                        this.router.navigate([`/lcr-form-dashboard`]);
                    }


                } else {
                    this.toastr.error(`${ response?.message }`);
                    // Reset various flags
                    this.resetFlags();
                    this.cdRef.detectChanges();
                }
                this.frmLCR.markAsPristine();
            },
                error => {
                    // Reset various flags
                    this.resetFlags();
                    this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
                    this.cdRef.detectChanges();
                });
        }
    }


    public onClick(e) {
        this.clickEventArgs = e.originalEvent;
    }

    // Display version history
    displayRevisionHistory(event) {

        const classList = Array.from(event.target.classList);

        if (classList.indexOf('version') >= 0) {
            this.revHistoryVisible = true;
            this.revHistoryDialog.show();
        }
    }

    // close version history modal popup
    revisionHistoryClose(event) {
        this.revHistoryDialog.hide();
        this.revHistoryVisible = false;
    }

    // display historic LCR form
    goToRevision(revisionId: number) {
        if (this.revHistoryDialog) {
            this.revHistoryDialog.hide();
            this.revHistoryVisible = false;
        }

        if (revisionId) {
            this.router.navigate([`/lcr-form/${ revisionId }`]);
        }
    }

    // Modal popup event to give user a choice
    buildLCRModal() {
        // SPL Revision Date is required for build
        this.f.splRevisionDate.setValidators([Validators.required]);
        this.f.splRevisionDate.updateValueAndValidity();
        this.submitted = true;

        // for certain SPL transmission type, the labeler code is required before build
        if (this.checkForSPLTransmissionType()) {
            this.f.drpNdcLabelerCode.setValidators([Validators.required]);
            this.f.drpNdcLabelerCode.updateValueAndValidity();
        } else {
            this.f.drpNdcLabelerCode.clearValidators();
            this.f.drpNdcLabelerCode.updateValueAndValidity();
        }

        if (this.frmLCR.invalid) {
            this.pageLoading = false;
            this.saveLoading = false;
            this.buildLoading = false;
        } else {

            // show modal for setting a version and cancel the build if Cancel is seleced.
            this.buildModalDialog.show();
            this.sub = this.confirmDialogSelection$.subscribe(choice => {
                if (!choice) {
                    this.buildLoading = false;
                    this.pageLoading = false;
                } else {
                    this.frmLCR.markAsDirty();
                    this.buildLoading = true;
                    this.pageLoading = true;
                    this.cdRef.detectChanges();
                    if (!this.buildLCRComplete) {
                        this.buildLCR();
                        this.buildLCRComplete = true;
                    }
                }
            });
        }
    }

    // when user click on the "continue" button on the SPL build popup
    buildDlgBtnYes: EmitType<object> = () => {
        // this.formData[0].data.splVersion = '' + this.updatedVersion;
        if (+this.updatedVersion > 0 || (this.versionToDisplay === 'Draft' && this.updatedVersion === '1')) {

            this.buildModalDialog.hide();
            return this.confirmDialogSelection$.next(true);
        } else {

            this.invalidSplVersion = true;
        }
    }

    // when user click on the "Cancel" button on the SPL build popup
    buildDlgBtnNo: EmitType<object> = () => {

        this.invalidSplVersion = false;

        const splInput = document.getElementById('splVersionModalInput');
        if (splInput) {
            (splInput as any).value = '';
        }
        this.buildModalDialog.hide();
        return this.confirmDialogSelection$.next(false);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    buildDlgButtons: Object[] = [{ click: this.buildDlgBtnNo.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.buildDlgBtnYes.bind(this), buttonModel: { content: 'Continue', isPrimary: true } }];

    onBuildModalOverlayClick: EmitType<object> = () => {
        this.buildModalDialog.hide();
    }

    // Increase SPL version by 1
    splVersionModalOpen() {
        const splInput = document.getElementById('splVersionModalInput');
        if (splInput) {
            if (this.lcrRevisions && this.lcrRevisions.length > 0) {
                if (this.lcrRevisions.length === 1 && this.lcrRevisions[0].formVersion.toLowerCase() === 'draft') {
                    (splInput as any).value = '1';
                } else {
                    (splInput as any).value = `${ +this.formData[0].data.splVersion + 1 }`;
                }
            } else { // brand new LCR form
                (splInput as any).value = '1';
            }
            this.updatedVersion = (splInput as any).value;
        }
    }

    // validate SPL version number
    validateSplVersionInput(event) {

        this.invalidSplVersion = false;

        if (event.target.value) {

            this.updatedVersion = parseInt(event.target.value, 10).toString();
        } else {

            this.updatedVersion = '';
        }
    }


    // Create an overlay effect for verision history modal popup
    onOverlayClick() {
        this.revHistoryDialog.hide();
        this.revHistoryVisible = false;
    }

    ngAfterViewInit() {
        this.cdRef.detectChanges();
        this.frmLCR.markAsPristine();
    }

    get f() { return this.frmLCR.controls; }

    // set the ignore warning flag for building SPL
    ignoreWarningsToggle() {
        this.ignoreWarnings = !this.ignoreWarnings;
    }

    // SPL Revision Date datapicker is being clicked
    onOpen(e: any) {
        this.frmLCR.markAsDirty();
    }

    // clean up
    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        this.utilService.toggleClientDropdownState(false);
    }

    showCompanyDialog(companyRevisionId?: number) {

        this.frmLCR.markAsDirty();
        this.pageLoading = true;

        if (companyRevisionId) {

            const companyData$ = forkJoin([this.companyService.getBusinessCategories(false),
            this.companyService.getCountries(),
            this.companyService.getContacts(),
            this.refDataService.GetAllBusinessOperationQualifier(),
            this.companyService.getCompanyRevisionHistory(companyRevisionId),
            this.companyService.getBusinessOperationQualifierByCompany(companyRevisionId.toString()),
            this.companyService.getCompanyById(companyRevisionId.toString()),
            this.companyService.getNDCLabelerCodesByCompany(companyRevisionId.toString())]
            ).pipe(catchError(err => of(err)
            )).subscribe(data => {

                if (this.companyDetailsComponent) {

                    this.companyDetailsComponent.companyData = data;
                    this.companyDetailsComponent.companyRevisionId = companyRevisionId.toString();
                    this.companyDetailsComponent.populateDataFromResolver();
                    this.companyDetailsComponent.setButtons();
                    this.companyDetailsComponent.getFormControlByName('status').patchValue('Active');
                    this.companyDetailsComponent.checkUserPermission();
                    this.companyDetailsComponent.ngAfterViewInit();
                }

                this.pageLoading = false;
                this.companyDialog.show();
            });
        } else {
            const companyData = [];

            this.sub = this.companyService.getBusinessCategories(false).subscribe(busCat => {
                companyData[0] = busCat;

                this.sub = this.companyService.getCountries().subscribe(countries => {
                    companyData[1] = countries;

                    this.sub = this.companyService.getContacts().subscribe(contacts => {
                        companyData[2] = contacts;

                        this.refDataService.GetAllBusinessOperationQualifier().subscribe(busQual => {

                            companyData[3] = busQual;

                            if (this.companyDetailsComponent) {

                                this.companyDetailsComponent.companyData = companyData;
                                this.companyDetailsComponent.companyRevisionId = '';
                                this.companyDetailsComponent.company = null;
                                this.companyDetailsComponent.companyHistory_grid_data = [];
                                this.companyDetailsComponent.populateDataFromResolver();
                                this.companyDetailsComponent.setButtons();
                                this.companyDetailsComponent.checkUserPermission();
                                this.companyDetailsComponent.ngAfterViewInit();
                            }

                            this.pageLoading = false;
                            this.companyDialog.show();

                        },
                          error => {
                            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
                            this.pageLoading = false;
                          });
                    });
                },
                  error => {
                    this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
                    this.pageLoading = false;
                  });
            },
              error => {
                this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
                this.pageLoading = false;
              });
        }
    }

    modalCompany(newCompany) {

        this.setSavedLabelerCompany(newCompany.companyRevisionId);

        this.companyDialogCancelButtonClicked();
    }


    setSavedLabelerCompany(companyRevisionId: any) {

        let contact;
        let company;

        this.sub = this.llService.getLCompanyTypesByCustomerGuid(this.customerGuid).subscribe(response => {

            const companyTypes = response['data'];

            this.formData[2].data = companyTypes;
            this.labelerCompanies = companyTypes['labelers'];

            company = this.labelerCompanies.find(c => c.companyRevisionId === companyRevisionId);

            if (company) {

                this.labelCompanyRevisionId = companyRevisionId;

                this.drpLabelerCompanyLOV = [];

                if (company.contacts && company.contacts.length > 0) {
                    this.labelCompanyRevisionId = company.contacts[0].contactRevisionId;
                    contact = company.contacts[0];
                }

                this.frmLCR.patchValue({
                    drpLabelerCompany: companyRevisionId,
                    registrantContact: contact
                });

                this.populateLabelerCompanyDrp();

                //this.drpLabelerCompanyLOV.sort(this.compare);

                this.lablerCompany.dataSource = this.drpLabelerCompanyLOV;
                this.lablerCompany.dataBind();
                this.lablerCompany.refresh();

                this.lablerCompany.value = companyRevisionId;

            }
            this.cdRef.detectChanges();
        },
          error => {
            this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
            this.pageLoading = false;
          });

        this.frmLCR.markAsDirty();
    }

    companyDialogCancelButtonClicked() {

        if (this.companyDetailsComponent) {

            this.companyDetailsComponent.companyForm.clearValidators();
        }
        this.companyDialog.hide();
    }

    contactDialogCancelButtonClicked() {

        if (this.contactComponent) {
            this.companyDetailsComponent.companyForm.clearValidators();
        }
        this.contactDialog.hide();
    }

    showContactDialog(contactRevisionId) {

        this.frmLCR.markAsDirty();
        this.pageLoading = true;

        if (this.contactComponent) {

            this.contactComponent.contactRevisionId = contactRevisionId;
            this.contactComponent.ngOnInit();

            this.contactComponent.contactDetailComponent.contactRevisionId = contactRevisionId;

            this.contactComponent.contactDetailComponent.getContactById();
            this.contactComponent.contactDetailComponent.ngOnInit();

            this.pageLoading = false;
        }
    }

    contactRetrieved(contact) {

        if (contact) {
            this.contactDialog.show();
        }
    }

    modalContact(updatedContact) {

        this.setSavedContact(updatedContact.contactRevisionId);

        this.contactDialogCancelButtonClicked();
    }

    setSavedContact(contactRevisionId: any) {

        this.contactDialogCancelButtonClicked();

    }


    compare(a, b) {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.bame) {
            return 1;
        }
        return 0;
    }

    showToolTip(event) {

        if (this.isEllipsisActive(event)) {

            event.target.setAttribute('title', event.target.textContent);
        }
    }
    showSFToolTip(event) {

        if (this.isEllipsisActive(event)) {

            if (this.tooltipObj) {
                this.tooltipObj.content = event.target.outerText;
                this.tooltipObj.width = `${ event.target.scrollWidth }px`;

                this.tooltipObj.open();
            }
        }
    }

    hideSFToolTip(event) {

        if (this.tooltipObj) {

            this.tooltipObj.close();
        }
    }

    isEllipsisActive(e) {
        return (e.target.offsetWidth < e.target.scrollWidth);
    }
}

